import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
export interface Bar {
  height: number;
  selected: boolean;
}
@Component({
  selector: 'string-tuning',
  templateUrl: './string-tuning.component.html',
  styleUrls: ['./string-tuning.component.scss']
})
export class StringTuningComponent implements OnInit {
  private nbBars = 5;
  public leftBars: Bar[] = [];
  public rightBars: Bar[] = [];
  public MAX_DETUNE = 5;
  public ldetune!: number;
  public detuneDisplay = '';

  @Input() multi = 1;
  @Input() set detune(value: number) {
    this.ldetune = value;
    this.initDetuneDisplay();
    this.barInit();
    this.barSelect();
  }
  @Output() detuneChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() detuneReset: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }
  ngOnInit() { }

  barInit() {
    this.leftBars = [];
    this.rightBars = [];
    for (let i = 0; i < this.nbBars; i++) {
      this.rightBars.push({
        height: (18 * this.multi) * (this.nbBars - i) / 5,
        selected: false
      });
      this.leftBars.push({
        height: (18 * this.multi) * (i + 1) / 5,
        selected: false
      });
    }
  }
  barSelect() {
    this.leftBars[this.nbBars - 1].selected = false;
    this.rightBars[0].selected = false;

    if (this.ldetune < 0) {
      const absValue = -this.ldetune;
      for (let i = 0; i < this.nbBars; i++) {
        const index = (this.nbBars - i - 1);
        this.leftBars[index].selected = (absValue > i);
      }
    }
    if (this.ldetune > 0) {
      const absValue = this.ldetune;
      for (let i = 0; i < this.nbBars; i++) {
        this.rightBars[i].selected = (absValue > i);
      }
    }
  }
  initDetuneDisplay() {
    this.detuneDisplay = '0';
    if (this.ldetune < 0) {
      this.detuneDisplay = '-' + Math.abs(this.ldetune);
    }
    if (this.ldetune > 0) {
      this.detuneDisplay = '+' + this.ldetune;
    }
  }
  decrease() {
    if (this.ldetune > -this.MAX_DETUNE) {
      this.detuneChange.emit(-1);
    }
  }
  increase() {
    if (this.ldetune < this.MAX_DETUNE) {
      this.detuneChange.emit(+1);
    }
  }
  resetTuning() {
    if (this.ldetune !== 0) {
      this.detuneReset.emit(true);
    }
  }
  getMainStyle() {
    return {
      // width: (136 * this.multi) + 'px',
      height: (19 * this.multi) + 'px',
      'font-size': '1px'
    };
  }
  getTuneStyle(isPlus: boolean) {
    let fontSize = (13 * this.multi);
    if (fontSize < 9) {
      fontSize = 0;
    }
    return {
      color: isPlus ? 'darkgreen' : 'red',
      width: (16 * this.multi) + 'px',
      margin: '0 ' + (4 * this.multi) + 'px',
      'font-size': fontSize + 'px'
    };
  }
  getIconStyle(isRight: boolean) {
    const obj = {
      // top: (-4 * this.multi) + 'px',
      'font-size': (16 * this.multi) + 'px'
    };
    /** if (isRight) {
      obj['left'] = (-8 * this.multi) + 'px';
      obj['margin'] = '0 ' + (5 * this.multi) + 'px 0 ' + (3 * this.multi) + 'px';
    } else {
      obj['right'] = (-8 * this.multi) + 'px';
      obj['margin'] = '0 ' + (3 * this.multi) + 'px 0 ' + (5 * this.multi) + 'px';
    } */
    return obj;
  }
}
